import { FormEvent, useEffect, useState } from "react";
import { Input, Form } from "../../components/molecules/Form";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom"
import { AlertComponent } from "../../components/shared/alert.component";
import { AppState } from "../../store/root.reducer";

import * as AuthActions from './store/auth.actions';
import Button from "../../components/molecules/Button";
import Heading from "../../components/atoms/Heading";

export const VerifyEmailPage = () => {
    //
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const email = searchParams.get('email');

    const auth = useSelector((state: AppState) => state.auth);
    
    const [verifyToken, setVerifyToken] = useState<string>();
    const [code, setCode] = useState<string>('');
    const [showAlert, setShowAlert] = useState(true);

    const [successAlert, setSuccessAlert] = useState(false);

    const onSubmit = () => {
        setShowAlert(true);
        dispatch(AuthActions.VerifyEmail({
            navigate, code, token: auth.token as string
        }));
    }

    const onResend = (e: any) => {
        e.preventDefault();
        dispatch(AuthActions.ResendVerifyEmail(email));
        setSuccessAlert(true);
    }

    useEffect(() => {
        const _verifyToken = localStorage.getItem('emailVerifyToken');
        setVerifyToken(_verifyToken);
    }, [])

    return (
        <>
            <div className="container">
                <Heading h2 className="my-1">
                    Confirmation code
                </Heading>
                <Form>
                    <Input 
                        title="We've sent a confirmation code to your email address.&#10;Please type it below"
                        className="multiline-title my-2"
                        value={code} 
                        onChange={(value: string) => setCode(value)} 
                        type="text" 
                        placeholder="Enter confirmation code" 
                    />
                    
                    <Button className="btn btn-success mt-3" type="submit" disabled={!verifyToken} onClick={onSubmit}>Submit</Button>
                    <div className="mt-4">
                        <div>Didn't receive a code? Please check your spam folder.</div>
                        <Link to="#" onClick={onResend} className="mt-1 text-decoration-none">Resend email</Link>
                    </div>
                    {/* <Button className="btn btn-success" type="button" onClick={onResend} disabled={!verifyToken}>Resend</Button> */}
                </Form>
            </div>
        </>
    )
}